import { Input } from '@/components/ui/input'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { cn } from '@/lib/utils'

export default function QuickOrderItemRow({
  item,
  productTypes,
  readOnly,
  onQuantityChange,
  onProductTypeChange
}) {
  const handleFocus = (e) => {
    if (e.target.value === '0') {
      e.target.value = ''
    }
  }

  const handleBlur = (e) => {
    if (e.target.value === '' || e.target.value.trim() === '') {
      onQuantityChange(item.product_id, '0')
    }
  }

  return (
    <div
      className={cn(
        'px-3 py-2.5',
        item.quantity > 0 && 'bg-green-50'
      )}
    >
      <div className="flex items-center justify-between gap-2 mb-1.5">
        <span className="font-medium text-sm flex-1">{item.productName}</span>
        {readOnly ? (
          <span className="text-xs text-muted-foreground">
            {productTypes.find(pt => pt.id === item.product_type_id)?.name || 'A Class'}
          </span>
        ) : (
          <Select
            value={item.product_type_id}
            onValueChange={(value) => onProductTypeChange(item.product_id, value)}
          >
            <SelectTrigger className="w-28 h-7 text-xs">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {productTypes.map(type => (
                <SelectItem key={type.id} value={type.id}>
                  {type.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        )}
      </div>
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          {readOnly ? (
            <span className="text-sm font-medium w-16 text-center">{item.quantity}</span>
          ) : (
            <Input
              type="number"
              min="0"
              step="0.1"
              value={item.quantity}
              onChange={(e) => onQuantityChange(item.product_id, e.target.value)}
              onFocus={handleFocus}
              onBlur={handleBlur}
              placeholder="0"
              className="w-16 h-9 text-center"
              inputMode="decimal"
            />
          )}
          <span className="text-xs text-muted-foreground">kg @ £{item.price.toFixed(2)}</span>
        </div>
        <span className={cn(
          'font-semibold text-sm',
          item.subtotal > 0 ? 'text-green-700' : 'text-muted-foreground'
        )}>
          £{item.subtotal.toFixed(2)}
        </span>
      </div>
    </div>
  )
}
